const SUPABASE_URL = 'https://hrhdzbtmxfkflbhrfhkm.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhyaGR6YnRteGZrZmxiaHJmaGttIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM1MTg2MjMsImV4cCI6MjA3OTA5NDYyM30.PF7Q_zsPVNI-wNaMx7MGnorf0NbY3Sq3EmJpxw5q2z8';

export { SUPABASE_URL, SUPABASE_ANON_KEY };
